module.exports = __webpack_public_path__ + "media/images/components/c04-welcome-boep/image-17050af74f704e74b995ed98c36925bb.svg";